// Model
import { Employee2 } from '../../../../../../model/Employee';

// Utils
import { getThemeStyles, Theme } from '../../../../../../util/style';

// Components
import EmployeeStatusBadge from './EmployeeStatusBadge';

// Lucide Icons
import { Eye, Edit3, Trash2 } from 'lucide-react';

export default function EmployeeTable({
    theme = 'light',
    employees,
    isLoading,
    onView,
    onEdit,
    onDelete,
}: {
    theme?: Theme;
    employees: Employee2[];
    isLoading?: boolean;
    onView?: (emp: Employee2) => void;
    onEdit?: (emp: Employee2) => void;
    onDelete?: (emp: Employee2) => void;
}) {
    const s = getThemeStyles(theme);

    return (
        <div className={`${s.card} rounded-xl shadow-lg overflow-hidden`}>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className={`${s.card}`}>
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Karyawan
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Jabatan
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status Kepegawaian
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Pendidikan
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Tanggal Bergabung
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Aksi
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {employees.length > 0 ? (
                            employees.map((emp, idx) => (
                            <tr key={idx}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-8 h-8 rounded-full overflow-hidden ${s.barBg} flex items-center justify-center text-sm text-blue-600 font-bold`}>
                                            {emp.foto_karyawan ? 
                                                <img src={process.env.REACT_APP_API_URL + "/storage/route/karyawan/" + encodeURIComponent(emp.nama) + "/" + emp.foto_karyawan} alt={emp.nama} className="w-full h-full object-cover"/>
                                            :
                                                (emp.nama ?? '').split(' ').map(n => n[0] || '').join('').slice(0, 2)
                                            }
                                        </div>
                                        <div>
                                            <div className="font-semibold">{emp.nama ?? '-'}</div>
                                            <div className="font-light">{emp.nik ?? '-'}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {emp.jabatan ?? '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <EmployeeStatusBadge status={emp.status_pegawai ?? '-'} />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {emp.pendidikan?.jenjang ?? ''} - {emp.pendidikan?.institusi ?? ''}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {emp.tgl_bergabung_formatted ?? '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex space-x-2">
                                        <button 
                                            onClick={() => onView?.(emp)}
                                            className="text-blue-600 hover:text-blue-900 p-1"
                                        >
                                            <Eye className="w-4 h-4" />
                                        </button>

                                        <button 
                                            onClick={() => onEdit?.(emp)}
                                            className="text-green-600 hover:text-green-900 p-1"
                                        >
                                            <Edit3 className="w-4 h-4" />
                                        </button>

                                        <button 
                                            disabled={isLoading}
                                            onClick={() => onDelete?.(emp)}
                                            className="text-red-600 hover:text-red-900 p-1"
                                        >
                                            <Trash2 className="w-4 h-4" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))) : (
                            <tr>
                                <td colSpan={6} className="px-6 py-4 whitespace-nowrap text-center">
                                    Tidak ada data yang cocok dengan filter atau pencarian.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}